<template>
  <div class="agentRegister" :class="{isInstitution: isInstitution}" v-loading="loading">
    <h1 v-if="!isInstitution">成为支付服务商</h1>
    <el-card shadow="never">
      <p class="errorMsg" v-show="isEdit && !readOnly"><span>驳回原因: </span>{{errorMsg}}</p>
      <el-collapse v-model="collapseList">
        <el-collapse-item name="sign">
          <template slot="title">
            <h2>{{companyType}}注册信息</h2>
          </template>
          <el-divider/>
          <el-form
            label-width="120px"
            ref="signInfo"
            label-position="left"
            :disabled="readOnly"
            :model="signInfo"
            :rules="rule_data">
            <el-form-item prop="subAgentClass" label="合作业务" v-show="!isInstitution">
              <el-select v-model="signInfo.subAgentClass" :disabled="isEdit || hasInfo" placeholder="请选择合作业务类型">
                <el-option v-for="item in agentType"
                  :key="'agentType' + item"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item ref="addFormUserNameItem" :label="companyType + '账号'" prop="agentAccount" :error="agentAccountError">
              <el-input v-model="signInfo.agentAccount" :disabled="isEdit" class="form-input" autoComplete="off" :placeholder="'8-20位小写字母、数字组合'+ companyType + '账号'"></el-input>
            </el-form-item>
            <el-form-item label="登录密码" prop="agentPassword" v-show="!isEdit" :required="!isEdit">
              <el-input class="form-input" type="password" v-model="signInfo.agentPassword" autoComplete="new-password" placeholder="8-20位大小写字母、数字、符号中的至少三种组合登录密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword" v-show="!isEdit" :required="!isEdit">
              <el-input class="form-input" type="password" v-model="signInfo.confirmPassword" autoComplete="new-password" placeholder="同登录密码保持一致" ></el-input>
            </el-form-item>
            <el-form-item label="绑定手机" prop="mobile">
              <el-input class="form-input" v-model="signInfo.mobile" :disabled="isEdit" placeholder="11位手机号"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input class="form-input" v-model="signInfo.email" placeholder="可填写多个邮箱，用英文分号;隔开"></el-input>
            </el-form-item>
          </el-form>
        </el-collapse-item>
        <el-collapse-item name="base">
          <template slot="title">
            <h2>{{companyType}}入网信息</h2>
          </template>
          <el-divider/>
          <el-form
            label-width="120px"
            ref="baseInfo"
            label-position="left"
            :model="baseInfo"
            :rules="rule_data"
            :disabled="readOnly">
            <el-form-item>
              <el-row type="flex" class="flexRow">
                <el-form-item prop="licensePic">
                  <ocr-recognition
                    type="10"
                    label="营业执照"
                    :value="baseInfo.licensePic"
                    :disabled="readOnly"
                    valueName="baseInfo.licensePic"
                    :to-check="needOcr"
                    @submit="getOCRResult"></ocr-recognition>
                </el-form-item>
                <el-form-item prop="idCardFrontPic">
                  <!--身份证可以ocr识别-->
                  <ocr-recognition
                    type="8"
                    label="法人身份证人像页"
                    :value="baseInfo.idCardFrontPic"
                    valueName="baseInfo.idCardFrontPic"
                    :disabled="readOnly"
                    :to-check="needOcr"
                    @submit="getOCRResult"></ocr-recognition>
                </el-form-item>
                <el-form-item prop="idCardBackPic">
                  <!--身份证可以ocr识别-->
                  <ocr-recognition
                    type="7"
                    label="法人身份证国徽页"
                    :value="baseInfo.idCardBackPic"
                    valueName="baseInfo.idCardBackPic"
                    :disabled="readOnly"
                    :to-check="needOcr"
                    @submit="getOCRResult"></ocr-recognition>
                </el-form-item>
              </el-row>
            </el-form-item>
            <el-form-item prop="bdName" label="业务BD">
              <el-input class="form-input" v-model.trim="baseInfo.bdName" placeholder="请输入乐刷业务BD姓名" maxlength="60" v-if="isInstitution"></el-input>
              <el-select class="form-input" v-model="baseInfo.bdName" placeholder="请选择乐刷业务BD姓名" :disabled="hasInfo" v-else>
                <el-option v-for="(item, index) in bdList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="enterpriseTitle" label="公司名称">
              <el-input class="form-input" v-model="baseInfo.enterpriseTitle" :disabled="hasInfo" placeholder="营业执照上全称"></el-input>
            </el-form-item>
            <el-form-item prop="license" label="统一信用代码">
              <el-input class="form-input" v-model="baseInfo.license" placeholder="营业执照注册号"></el-input>
            </el-form-item>
            <el-form-item prop="registeredCapital" label="注册资金(万元)" >
              <el-input class="form-input" v-model="baseInfo.registeredCapital" placeholder="输入整数"></el-input>
            </el-form-item>
            <expiry-date
              ref="licenseExpiryDate"
              label="营业执照过期时间"
              label-width="135px"
              :value="licenseExpiryDate"
              :read-only="readOnly"
              valueName="licenseExpiryDate"
              mode='end'
              @change="getExpiryDate"></expiry-date>
            <el-form-item label="公司所在地" required>
              <address-select
                ref="addressSelectForm"
                v-model="businessAddress"
                :value="businessAddress"
                :value-name="businessAddressName"
                :readOnly="readOnly"
                @getValue="getAddress"
                @getNameValue="getAddressName"></address-select>
            </el-form-item>
            <el-form-item label="公司法人姓名" prop="legalName">
              <el-input class="form-input" v-model="baseInfo.legalName" placeholder="至少2位"></el-input>
            </el-form-item>
            <el-form-item label="法人身份证号" prop="legalIdentityCard">
              <el-input class="form-input" v-model="baseInfo.legalIdentityCard" placeholder="15/18位身份证号"></el-input>
            </el-form-item>
            <el-form-item prop="legalMobile" label="法人手机号">
              <el-input class="form-input" v-model="baseInfo.legalMobile" placeholder="请输入法人手机"></el-input>
            </el-form-item>
            <expiry-date
              ref="idCardExpiryDate"
              label="法人证件过期时间"
              label-width="135px"
              :value="idCardExpiryDate"
              :read-only="readOnly"
              value-name="legalIdCardExpiryDate"
              mode='end'
              @change="getExpiryDate"></expiry-date>
            <el-form-item label-width="120px" label="合作协议原件" prop="cooperationPic" style="margin-bottom: 32px">
              <div>
                <input type="file" ref="file" @change="getFile($event, 'cooperationPic')" style="display:none"/>
                <span class="upload-link" @click="getMultiFiles('file')">点击上传</span>
                <span>(仅支持PNG,JPG, PDF格式图片附件或文件)</span>
                <el-col v-if="otherInfo.cooperationPic !== ''" class="hasSelect">
                  <a class="upload-link" download :href="downloadLink('cooperationPic')">已上传文件</a>
                  <i class="el-icon-remove removeIcon" @click="removeFile('cooperationPic')"></i>
                </el-col>
              </div>
          </el-form-item>
          <el-form-item label-width="120px" label="租赁协议" prop="agreementPic">
            <div>
              <input type="file" ref="file1" @change="getFile($event, 'agreementPic')" style="display:none"/>
              <span class="upload-link" @click="getMultiFiles('file1')">点击上传</span>
              <span>(仅支持PNG,JPG, PDF格式图片附件或文件)</span>
              <el-col v-if="otherInfo.agreementPic !== ''" class="hasSelect">
                <a class="upload-link" download :href="downloadLink('agreementPic')">已上传文件</a>
                <i class="el-icon-remove removeIcon" @click="removeFile('agreementPic')"></i>
              </el-col>
            </div>
          </el-form-item>
          </el-form>
        </el-collapse-item>
        <el-collapse-item name="settle">
          <template slot="title">
            <h2>{{companyType}}结算信息（只支持对公结算）</h2>
          </template>
          <el-divider/>
          <el-form
            label-width="120px"
            ref="settleInfo"
            label-position="left"
            :model="settleInfo"
            :disabled="readOnly"
            :rules="rule_data">
            <el-form-item label="开户许可证" prop="openingPermitPic">
              <upload-img-ele
                :value="settleInfo.openingPermitPic"
                valueName="settleInfo.openingPermitPic"
                @upload="uploadSuccess"></upload-img-ele>
                <p class="form-tip-label">注：若无开户许可证，可用身份证，营业执照，结算确认书或其他图片进行代替</p>
            </el-form-item>
            <el-form-item label="开户名" prop="bankAccount">
              <el-input class="form-input" v-model="settleInfo.bankAccount" placeholder="开户许可证上公司名称"></el-input>
            </el-form-item>
            <el-form-item id="bankCardId" label="开户号" prop="bankCardid">
              <el-input class="form-input bankCardId" v-model="settleInfo.bankCardid" placeholder="开户许可证账号"></el-input>
            </el-form-item>
            <el-form-item label="确认开户号" prop="confirmBankCardId">
              <el-input class="form-input" v-model="settleInfo.confirmBankCardId" placeholder="再次确认开户许可证账号"></el-input>
            </el-form-item>
            <bank-branch
              ref="bankBranchForm"
              :value="bankBranch"
              v-model="bankBranch"
              :bankCardId="settleInfo.bankCardNo"
              label-width="120px"
              :readOnly="readOnly"
              @getValue="getBankBranch"
              @error="getBranchError"
              :showTips="true"></bank-branch>
            <el-form-item label="预留号码" prop="bankMobile">
              <el-input class="form-input" v-model="settleInfo.bankMobile" clearable placeholder="开户号银行预留号码"></el-input>
            </el-form-item>
          </el-form>
        </el-collapse-item>
        <el-collapse-item name="otherPic">
          <template slot="title">
            <h2>其他资料</h2>
          </template>
          <el-divider/>
          <el-form
            label-width="0"
            ref="otherInfo"
            :disabled="readOnly"
            :model="otherInfo"
            :rules="rule_data">
            <div class="photos-content-view">
              <!-- <el-form-item label="" prop="agreementPic">
                <upload-img-ele
                  v-model="otherInfo.agreementPic"
                  :value="otherInfo.agreementPic"
                  :disabled="readOnly"
                  valueName="otherInfo.agreementPic"
                  label="租赁协议或房产证明"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item> -->
              <el-form-item label="" prop="outerPic">
                <upload-img-ele
                  label="公司门头照片"
                  v-model="otherInfo.outerPic"
                  :value="otherInfo.outerPic"
                  :disabled="readOnly"
                  valueName="otherInfo.outerPic"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item>
              <el-form-item label="" prop="innerPic">
                <upload-img-ele
                  label="公司场所照片"
                  v-model="otherInfo.innerPic"
                  :value="otherInfo.innerPic"
                  :required="false"
                  :disabled="readOnly"
                  valueName="otherInfo.innerPic"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item>
              <el-form-item label="" prop="bdagentPic">
                <upload-img-ele
                  :label="companyType + 'BD合影'"
                  v-model="otherInfo.bdagentPic"
                  :value="otherInfo.bdagentPic"
                  :required="false"
                  :disabled="readOnly"
                  valueName="otherInfo.bdagentPic"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item>
              <el-form-item label="" prop="tradingFlowPic">
                <upload-img-ele
                  label="交易数据截图"
                  v-model="otherInfo.tradingFlowPic"
                  :value="otherInfo.tradingFlowPic"
                  :required="false"
                  :disabled="readOnly"
                  valueName="otherInfo.tradingFlowPic"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item>
              <el-form-item label="" prop="wechatRiskPic">
                <upload-img-ele
                  label="微信服务商后台"
                  desc="【风险商户管理】"
                  v-model="otherInfo.wechatRiskPic"
                  :value="otherInfo.wechatRiskPic"
                  :required="false"
                  :disabled="readOnly"
                  valueName="otherInfo.wechatRiskPic"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item>
              <el-form-item label="" prop="wechatComplaintPic">
                <upload-img-ele
                  label="微信服务商后台"
                  desc="【消费者投诉界面】"
                  :required="false"
                  :disabled="readOnly"
                  v-model="otherInfo.wechatComplaintPic"
                  :value="otherInfo.wechatComplaintPic"
                  valueName="otherInfo.wechatComplaintPic"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="buttonDiv" v-show="!readOnly">
        <el-button class="submitBtn" type="primary" @click="submit" :loading="submitLoading">提交</el-button>
        <el-button @click="close">取消</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import qs from 'qs'
// import luhmCheck from '@/utils/luhmCheck.js'
import ocrRecognition from '@/components/OCRRecognition'
import addressSelect from '@/components/addressSelect'
import expiryDate from '../merchant/components/expiryDate'
import uploadImgEle from '@/components/upload/uploadImgEle'
import bankBranch from '@/components/bankBranch'
// import { uploadPic, singleTransPic, agentSurvey, getInfoByAuthCode } from '@/api/global'
import { agentRegisterNew, updateRegister, checkAuthBusiness, checkAuthIdCard } from '@/api/merchant'
import { uploadExtendFile } from '@/api/global'
import { synAgentId, getBdInfo } from '@/api/user'
import md5 from 'js-md5'
export default {
  name: 'AgentRegister',
  components: {
    ocrRecognition,
    addressSelect,
    expiryDate,
    uploadImgEle,
    bankBranch
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    errorMsg: {
      type: String,
      default: ''
    },
    fromBd: {
      type: Boolean,
      default: false
    },
    bdInfo: {
      type: String,
      default: ''
    },
    isInstitution: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      collapseList: ['sign', 'base', 'settle', 'otherPic'],
      signInfo: {
        agentId: '',
        agentAccount: '',
        agentPassword: '',
        confirmPassword: '',
        mobile: '',
        email: '',
        subAgentClass: ''
      },
      baseInfo: {
        licensePic: '',
        idCardFrontPic: '',
        idCardBackPic: '',
        bdName: '',
        enterpriseTitle: '',
        license: '',
        registeredCapital: '',
        agentProvince: '',
        agentProvinceCode: '',
        agentCity: '',
        agentCityCode: '',
        agentArea: '',
        agentAreaCode: '',
        agentAddress: '',
        legalName: '',
        legalIdentityCard: '',
        legalMobile: '',
        licenseExpiryDate: '',
        legalIdCardExpiryDate: ''
      },
      settleInfo: {
        openingPermitPic: '',
        bankAccount: '',
        bankCardid: '',
        confirmBankCardId: '',
        bankTypeCode: '',
        bankCityCode: '',
        bankProvinceCode: '',
        unionpayCode: '',
        bankMobile: ''
      },
      otherInfo: {
        agreementPic: '',
        cooperationPic: '',
        outerPic: '',
        innerPic: '',
        bdagentPic: '',
        tradingFlowPic: '',
        wechatRiskPic: '',
        wechatComplaintPic: ''
      },
      rule_data: {
        agentAccount: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(`请输入${this.companyType}账号`))
            } else if (/^[a-z0-9]{8,20}$/.test(value)) {
              callback()
            } else {
              callback(new Error(`请输入8-20位小写字母、数字组合${this.companyType}账号`))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        subAgentClass: [{
          required: true,
          message: '请选择合作业务',
          trigger: 'change'
        }],
        agentPassword: [{
          validator: (rule, value, callback) => {
            if (!this.isEdit && !value) {
              callback(new Error('请输入登录密码'))
            } else if (/^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)[^\u4e00-\u9fa5\s]{8,20}$/.test(value) || this.isEdit) {
              callback()
            } else {
              callback(new Error('请输入8-20位大小写字母、数字、符号中的至少三种组合登录密码'))
            }
          },
          trigger: 'blur'
        }],
        confirmPassword: [{
          validator: (rule, value, callback) => {
            if (!this.isEdit && !value) {
              callback(new Error('请输入确认密码'))
            } else if (value !== this.signInfo.agentPassword && !this.isEdit) {
              callback(new Error('两次输入的密码不一致!'))
            } else {
              callback()
            }
          }
        }],
        mobile: [{
          validator: (rule, value, callback) => {
            if (!(/^\d{11,11}$/.test(value))) {
              callback(new Error('请输入11位手机号码'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        email: [{
          required: true,
          pattern: /^([A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4};)*[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
          trigger: 'blur',
          message: '邮箱格式错误，请重新输入'
        }],
        bdName: [{
          required: true,
          message: '请输入至少1位业务BD',
          pattern: /[\u4e00-\u9fa5a-zA-Z]{1,60}$/,
          trigger: 'blur'
        }],
        enterpriseTitle: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入公司名称'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?![^\u4E00-\u9FA5]+$)^.{2,40}$/.test(value)) {
                callback()
              } else {
                callback(new Error('公司名称为长度2~40的汉字或汉字与数字组合'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        license: [
          { required: true, message: '请输入统一信用代码', trigger: 'blur' },
          {
            pattern: /(^[A-Za-z\d]{15}$)|(^[A-Za-z\d]{18}$)/,
            required: true,
            message: '请输入15/18位统一信用代码',
            trigger: 'blur'
          }
        ],
        registeredCapital: [
          { required: true, message: '请输入注册资金', trigger: 'blur' },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            required: true,
            message: '请输入正整数金额',
            trigger: 'blur'
          }
        ],
        legalName: [{
          required: true,
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入法人姓名'))
            } else {
              if (!/^\S*$/.test(value)) {
                callback(new Error('空格无效，请重新输入'))
              } else if (value.includes('*') && value !== this.encryptedInfo.legalName) {
                callback(new Error('请输入正确的法人姓名'))
              } else {
                callback()
              }
            }
          }
        }],
        legalIdentityCard: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入法人身份证号'))
            } else {
              if ((/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) || value === this.encryptedInfo.legalIdentityCard) {
                callback()
              } else {
                callback(new Error('请输入正确的法人身份证号'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        legalMobile: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入法人手机号'))
            } else {
              if (/^\d{11,11}$/.test(value) || value === this.encryptedInfo.legalMobile) {
                callback()
              } else {
                callback(new Error('请输入正确的法人手机号'))
              }
            }
          },
          trigger: 'blur'
        }],
        openingPermitPic: [{
          required: true,
          message: '请上传开户许可证照片',
          trigger: 'change'
        }],
        cooperationPic: [{
          validator: (rule, value, callback) => {
            if (!this.otherInfo.cooperationPic) {
              callback(new Error('请上传合作协议原件'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'change'
        }],
        agreementPic: [{
          validator: (rule, value, callback) => {
            if (!this.otherInfo.agreementPic) {
              callback(new Error('请上传租赁协议'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'change'
        }],
        bankAccount: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入正确的开户名'))
            } else {
              if (/^[\u4e00-\u9fa5a-zA-Z()（）]{1,60}$/.test(value) || value === this.encryptedInfo.bankAccount) {
                callback()
              } else if (!/^\S*$/.test(value)) {
                callback(new Error('空格无效，请重新输入'))
              } else {
                callback(new Error('请输入正确的开户名'))
              }
            }
          },
          trigger: 'blur'
        }],
        bankCardid: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入正确的开户许可证账号'))
            } else {
              // eslint-disable-next-line no-useless-escape
              if (/^\d{5,24}$/.test(value) || value === this.encryptedInfo.bankCardid) {
                callback()
              } else {
                callback(new Error('请输入正确的开户许可证账号'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        confirmBankCardId: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入确认开户号'))
            } else if (value !== this.settleInfo.bankCardid) {
              callback(new Error('两次输入的开户号不一致!'))
              // eslint-disable-next-line no-useless-escape
            } else if (!(/^[\d|\*]{5,24}$/.test(value))) {
              callback(new Error('请输入正确的开户许可证账号'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        bankMobile: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              const check = (/^(\d{3,4}-?)?\d{7,9}$/.test(value) || /^(((13[0-9]{1})|(15[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(16[0-9]{1})|(19[0-9]{1}))+\d{8})$/.test(value))
              if (check || this.readOnly || value === this.encryptedInfo.bankMobile) {
                callback()
              } else {
                callback(new Error('请输入正确手机号或座机号'))
              }
            }
          },
          trigger: 'blur'
        }],
        outerPic: [{
          required: true,
          message: '请上传公司门头照片',
          trigger: 'change'
        }]
      },
      licenseExpiryDate: {
        dateEnd: '',
        longTermTag: false,
        valueName: 'licenseExpiryDate'
      }, // 营业执照有效期
      idCardExpiryDate: {
        dateEnd: '',
        longTermTag: false,
        valueName: 'legalIdCardExpiryDate'
      }, // 证件有效期
      bankTypeError: false, // 银行名称是否正确
      submitLoading: false,
      needOcr: true,
      isEdit: false,
      agentType: [
        {
          label: 'SAAS',
          value: 0
        },
        // {
        //   label: '云闪付代理商',
        //   value: 1
        // },
        // {
        //   label: '威富通代理商',
        //   value: 2
        // },
        // {
        //   label: '富友系代理商',
        //   value: 3
        // },
        // {
        //   label: '网商系代理商',
        //   value: 4
        // },
        {
          label: '收银通',
          value: 5
        },
        {
          label: '联合收单',
          value: 6
        }
      ],
      licenseLegalName: '', // 营业执照ocr法人姓名
      idCardName: '', // 身份证ocr姓名
      // 身份证二要素鉴定
      userInfo: {
        name: '',
        idcard: ''
      },
      // 工商鉴权
      businessInfo: {
        companyName: '',
        creditCode: ''
      },
      // 加密信息缓存
      encryptedInfo: {
        legalName: '',
        legalIdentityCard: '',
        legalMobile: '',
        bankAccount: '',
        bankCardid: '',
        confirmBankCardId: '',
        bankMobile: ''
      },
      cooperationShowPath: '',
      // 2021-06-23 BD 过渡方案
      bdList: [
        {
          label: '钟必升-Curry',
          value: 'curryzhong'
        }
        // {
        //   label: '徐景军-Darren',
        //   value: 'darrenxu'
        // }, {
        //   label: '王川-Sunny',
        //   value: 'sunnywang'
        // }, {
        //   label: '李函坡-Torres',
        //   value: 'torresli'
        // }, {
        //   label: '钟必升-Curry',
        //   value: 'curryzhong'
        // }, {
        //   label: '朱敏-Jimmy',
        //   value: 'jimmyzhu'
        // }, {
        //   label: '位永强-Eric',
        //   value: 'ericwei'
        // }, {
        //   label: '袁磊基-Leo',
        //   value: 'leoyuan'
        // }, {
        //   label: '孙翊萌-Ally',
        //   value: 'v_ally'
        // }, {
        //   label: '马传波-chuanboma',
        //   value: 'v_chuanboma'
        // }, {
        //   label: '肖德会-Jack',
        //   value: 'v_jackxiao'
        // }, {
        //   label: '曹娟娟-Jamie',
        //   value: 'v_jamie'
        // }, {
        //   label: '张连勇-Lianyongzhang',
        //   value: 'v_lianyongzhang'
        // }, {
        //   label: '李强-Qiangli',
        //   value: 'v_qiangli'
        // }, {
        //   label: '刘荣灿-Rongcanliu',
        //   value: 'v_rongcanliu'
        // }, {
        //   label: '黄李周-Ali',
        //   value: 'v_ali'
        // }, {
        //   label: '支金波-Amy',
        //   value: 'v_amyzhi'
        // }, {
        //   label: '陶引济-Sunred',
        //   value: 'v_sunred'
        // }, {
        //   label: '梁宏明-Rambo',
        //   value: 'v_rambo'
        // }, {
        //   label: '明小玉-Kevin',
        //   value: 'v_kevinming'
        // }, {
        //   label: '黄俊文-Shark',
        //   value: 'v_shark'
        // }
      ],
      hasInfo: false,
      bdId: ''
    }
  },
  computed: {
    // 经营地址
    businessAddress () {
      return {
        provinceCode: this.baseInfo.agentProvinceCode,
        cityCode: this.baseInfo.agentCityCode,
        areaCode: this.baseInfo.agentAreaCode,
        address: this.baseInfo.agentAddress
      }
    },
    businessAddressName () {
      return {
        province: this.baseInfo.agentProvince,
        city: this.baseInfo.agentCity,
        area: this.baseInfo.agentArea
      }
    },
    bankBranch () {
      return {
        bankNameCode: this.settleInfo.bankTypeCode, // 银行类型编码
        bankCityCode: this.settleInfo.bankCityCode, // 银行网点市编码
        bankAreaCode: this.settleInfo.bankProvinceCode, // 银行网点省编码
        bankBranchCode: this.settleInfo.unionpayCode// 分行id
      }
    },
    companyType () {
      return this.isInstitution ? '机构' : '代理商'
    }
  },
  watch: {
    value: {
      handler (val) {
        if (JSON.stringify(val) !== '{}') {
          this.isEdit = true
          this.setInfo(val)
        } else {
          this.isEdit = false
          this.isInstitution && (this.signInfo.subAgentClass = 0)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    if (!this.readOnly && !this.isInstitution) {
      // 读取本地存储数据
      this.getLocalStorageAddInfo()
      // 设置触发对应事件时进行本地存储
      this.setStoreOnEvent()
    }
    if (this.fromBd) {
      getBdInfo({ item: this.bdInfo }).then(res => {
        if (parseInt(res.error_code) === 0) {
          if (res.data.id) {
            this.bdId = res.data.id
            if (parseInt(res.data.productType) === 0) {
              this.signInfo.subAgentClass = 0
            } else if (parseInt(res.data.productType) === 1) {
              this.signInfo.subAgentClass = 5
            } else {
              this.signInfo.subAgentClass = 6
            }
            this.baseInfo.bdName = res.data.bdOperator
            this.baseInfo.enterpriseTitle = res.data.companyName
            this.hasInfo = true
          }
        } else {
          this.$message({
            type: 'error',
            message: res.error_msg,
            showClose: true
          })
        }
      })
    }
  },
  methods: {
    /**
     * @description orc识别数据回填
     */
    getOCRResult (data) {
      if (data.success) {
        switch (data.valueName) {
          case 'baseInfo.licensePic': {
            // 营业执照
            if (!this.hasInfo) {
              this.baseInfo.enterpriseTitle = data.name
            }
            this.baseInfo.merchantName = data.name
            this.baseInfo.license = data.licenseNo
            this.licenseLegalName = data.legalName
            if (!this.baseInfo.legalName || this.baseInfo.legalName !== this.idCardName) {
              this.baseInfo.legalName = data.legalName
            }
            // 判断营业执照OCR与身份证OCR中的姓名
            if (this.idCardName && this.idCardName !== this.licenseLegalName) {
              this.$alert('营业执照法人与身份证姓名不一致，请检查修改', '提示', {
                confirmButtonText: '确定'
              })
            }
            let end
            if (data.endDate) {
              if (data.endDate.includes('长期') || data.endDate.includes('不约定期限') || data.endDate.includes('永久')) {
                end = '2099-12-30'
              } else {
                end = this.formatDate(data.endDate)
              }
            } else {
              if (data.period.includes('长期') || data.period.includes('不约定期限') || data.period.includes('永久')) {
                end = '2099-12-30'
              } else {
                end = data.period.split('至')[1]
                end = this.formatDate(end)
              }
            }
            this.licenseExpiryDate.dateEnd = end === '2099-12-30' ? '' : end
            this.licenseExpiryDate.longTermTag = end === '2099-12-30'
            break
          }
          case 'baseInfo.idCardFrontPic': {
            // 身份证人像面
            this.baseInfo.idCardName = data.name
            this.baseInfo.legalIdentityCard = data.idcard
            this.idCardName = data.name
            if (!this.baseInfo.legalName || this.baseInfo.legalName !== this.licenseLegalName) {
              this.baseInfo.legalName = data.name
            }
            // 判断营业执照OCR与身份证OCR中的姓名
            if (this.licenseLegalName && this.idCardName !== this.licenseLegalName) {
              this.$alert('营业执照法人与身份证姓名不一致，请检查修改', '提示', {
                confirmButtonText: '确定'
              })
            }
            break
          }
          case 'baseInfo.idCardBackPic': {
            // 身份证国徽面
            const end = this.formatDate(data.validDate.split('-')[1])
            this.idCardExpiryDate.dateEnd = end === '2099-12-30' ? '' : end
            this.idCardExpiryDate.longTermTag = end === '2099-12-30'
            break
          }
        }
      }
      if (data.path) {
        this.uploadSuccess({
          error_code: '0',
          valueName: data.valueName,
          path: data.path
        })
      }
      if (!this.readOnly) {
        this.storeToLocal()
      }
    },
    // 日期格式转换，含有年月日或纯数字，转换成-
    formatDate (str) {
      // ocr识别出错兼容
      if (!str || str === '无') {
        return ''
      }
      try {
        if (str.includes('年')) {
          const year = str.split('年')[0].trim()
          const month = str.split('年')[1].split('月')[0].trim()
          const day = str.split('年')[1].split('月')[1].split('日')[0].trim()
          return year + '-' + month + '-' + day
        } else if (str.length >= 8) {
          const year = str.substr(0, 4)
          const month = str.substr(4, 2)
          const day = str.substr(6, 2)
          return year + '-' + month + '-' + day
        } else {
          return ''
        }
      } catch (error) {
        console.log(error)
        return ''
      }
    },
    /**
     * @description 获取地址选择内容
     */
    getAddress (val) {
      this.baseInfo.agentProvinceCode = val.provinceCode
      this.baseInfo.agentCityCode = val.cityCode
      this.baseInfo.agentAreaCode = val.areaCode
      this.baseInfo.agentAddress = val.address
    },
    /**
     * @description 获取地址选择内容文本
     */
    getAddressName (val) {
      this.baseInfo.agentProvince = val.province
      this.baseInfo.agentCity = val.city
      this.baseInfo.agentArea = val.area
    },
    /**
     * @description 图片上传成功的回调
     */
    uploadSuccess (data) {
      if (data.error_code === '0') {
        const name = data.valueName
        if (name.includes('.')) {
          this[name.split('.')[0]][name.split('.')[1]] = data.path
          this.$refs[name.split('.')[0]].validateField(name.split('.')[1])
        } else {
          this[name] = data.path
          this.$refs.otherInfo.validateField(name)
        }
        if (!this.readOnly) {
          this.storeToLocal()
        }
      }
    },
    /**
     * @description 银行分行选中回调
     * @param {Object} val 组件传的参数，分行选中数据
     */
    getBankBranch (val) {
      this.settleInfo.bankTypeCode = val.bankNameCode// 银行类型编码
      this.settleInfo.bankCityCode = val.bankCityCode// 银行类型编码
      this.settleInfo.bankProvinceCode = val.bankAreaCode// 银行类型编码
      this.settleInfo.unionpayCode = val.bankBranchCode// 分行id
    },
    /**
     * @description 银行分行联动银行错误回调
     * @param {Object} value 组件传的参数，银行名称是否错误
     */
    getBranchError (value) {
      this.bankTypeError = value
    },
    /**
     * @description 提交表单
     */
    async submit () {
      if (!this.checkFormInfo()) return
      if (this.bankTypeError) {
        await this.$confirm('卡号与开户行不匹配，是否确认提交？', '提示', {}).then(() => {
        })
      }
      this.submitLoading = true
      let checkResult = true
      // 工商鉴权
      if (!this.businessInfo.companyName || !this.businessInfo.creditCode || this.businessInfo.companyName !== this.baseInfo.enterpriseTitle || this.businessInfo.creditCode !== this.baseInfo.license) {
        this.businessInfo.companyName = this.baseInfo.enterpriseTitle
        this.businessInfo.creditCode = this.baseInfo.license
        await checkAuthBusiness(qs.stringify(this.businessInfo)).then(res => {
          if (parseInt(res.result_cde) !== 200) {
            this.$message({
              type: 'error',
              message: res.result_msg,
              showClose: true
            })
            checkResult = false
          }
        })
      }
      if (!checkResult) {
        this.submitLoading = false
        return
      }
      // 身份证二要素鉴权
      if (!this.userInfo.name || !this.userInfo.idcard || this.userInfo.name !== this.baseInfo.legalName || this.userInfo.idcard !== this.baseInfo.legalIdentityCard) {
        this.userInfo.name = this.baseInfo.legalName
        this.userInfo.idcard = this.baseInfo.legalIdentityCard
        const params = qs.stringify(Object.assign({}, this.userInfo, { agentId: this.signInfo.agentId }))
        await checkAuthIdCard(params).then(res => {
          if (parseInt(res.result_cde) !== 200) {
            this.$message({
              type: 'error',
              message: res.result_msg,
              showClose: true
            })
            checkResult = false
          }
        })
      }
      if (!checkResult) {
        this.submitLoading = false
        return
      }
      const that = this
      const psd = !this.isEdit ? {
        agentPassword: md5(that.signInfo.agentPassword),
        confirmPassword: md5(that.signInfo.confirmPassword)
      } : {}
      const data = qs.stringify(Object.assign({
        agentQualification: this.isInstitution ? 2 : 3
      }, this.signInfo, this.baseInfo, this.settleInfo, this.otherForm, this.otherInfo, psd))
      // 提交接口
      this.submitLoading = false
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.submitLoading = true
        if (JSON.stringify(this.value) !== '{}') {
          updateRegister(data).then(res => {
            this.resolveSubmit(res)
          })
        } else {
          agentRegisterNew(data).then(res => {
            if (this.hasInfo && res.result_cde === '0') {
              synAgentId({
                agentId: res.data.agentId,
                id: this.bdId,
                bdOperator: this.baseInfo.bdName
              })
            }
            this.resolveSubmit(res)
          })
        }
      })
    },
    /**
     * @description 校验表单
     */
    checkFormInfo () {
      let signValid = false
      let baseValid = false
      let settleValid = false
      let otherValid = false
      let licenseDateValid = false
      let idCardExpiryDate = false
      this.$refs.signInfo.validate((valid, error) => {
        signValid = valid
        return valid
      })
      this.$refs.baseInfo.validate((valid) => {
        baseValid = valid
        return valid
      })
      this.$refs.settleInfo.validate((valid) => {
        settleValid = valid
        return valid
      })
      this.$refs.otherInfo.validate((valid) => {
        otherValid = valid
        return valid
      })
      this.$refs.licenseExpiryDate.$refs.form.validate((valid) => {
        licenseDateValid = valid
        return valid
      })
      this.$refs.idCardExpiryDate.$refs.form.validate((valid) => {
        idCardExpiryDate = valid
        return valid
      })
      console.log(signValid, baseValid, settleValid, licenseDateValid, idCardExpiryDate, otherValid)
      if (!signValid || !baseValid || !settleValid || !licenseDateValid || !idCardExpiryDate || !otherValid) {
        this.$message({
          message: `${this.companyType}信息有误或不完整，请完善相关信息`,
          type: 'warning'
        })
        return false
      }
      return true
    },
    /**
     * @description 关闭弹窗校验报错清除
     */
    close () {
      this.$emit('update:visible', false)
      if (this.isInstitution) {
        this.$router.push('/Partner/Institution/institutionList')
      }
      this.$refs.signInfo.resetFields()
      this.$refs.baseInfo.resetFields()
      this.$refs.settleInfo.resetFields()
      this.$refs.otherInfo.resetFields()
      this.$refs.licenseExpiryDate.$refs.form.resetFields()
      this.$refs.idCardExpiryDate.$refs.form.resetFields()
      this.$refs.addressSelectForm.$refs.form.resetFields()
      this.$refs.bankBranchForm.$refs.form.resetFields()
    },
    /**
     * @description 读取本地存储数据方法
     */
    async getLocalStorageAddInfo () {
      const storageAddInfo = localStorage.getItem('AGENT_ADD_INFO')
      // 判断是否未改动
      const addInfo = {
        signInfo: { ...this.$options.data().signInfo }, // JSON.parse(JSON.stringify(this.addForm))
        baseInfo: { ...this.$options.data().baseInfo },
        settleInfo: { ...this.$options.data().settleInfo },
        otherInfo: { ...this.$options.data().otherInfo },
        encryptedInfo: { ...this.$options.data().encryptedInfo },
        licenseExpiryDate: { ...this.$options.data().licenseExpiryDate },
        idCardExpiryDate: { ...this.$options.data().idCardExpiryDate }
      }
      const defaultStorageAddInfo = JSON.stringify(addInfo)
      if (storageAddInfo && storageAddInfo !== 'undefined' && defaultStorageAddInfo !== storageAddInfo) {
        await this.$confirm('是否要读取已保存表单数据？', '提示', {
          confirmButtonText: '读取',
          cancelButtonText: '不读取',
          closeOnClickModal: false
        }).then(() => {
          const storageAddInfoObj = JSON.parse(storageAddInfo)
          for (const key in storageAddInfoObj) {
            // eslint-disable-next-line no-prototype-builtins
            if (storageAddInfoObj.hasOwnProperty(key)) {
              this[key] = storageAddInfoObj[key]
            }
          }
          this.needOcr = false
        }).catch(() => {

        })
        this.needOcr = true
      }
    },
    /**
     * @description 设置触发对应事件时进行本地存储
     */
    setStoreOnEvent () {
      const eventArr = ['blur', 'change', 'select']
      const self = this
      function getChildrenItem (item) {
        if (item.$el.className && !item.$el.className.includes('el-select') && !item.$el.className.includes('el-input') && !item.$el.className.includes('el-checkbox') && !item.$el.className.includes('el-autocomplete')) {
          item.$children.forEach(element => {
            getChildrenItem(element)
          })
        } else {
          eventArr.forEach(eventStr => {
            item.$on(eventStr, event => {
              self.storeToLocal()
            })
          })
        }
      }
      const refs = this.$refs
      for (const key in refs) {
        // eslint-disable-next-line no-prototype-builtins
        if (refs.hasOwnProperty(key)) {
          if (['signInfo', 'baseInfo', 'settleInfo', 'otherInfo'].includes(key)) {
            const element = refs[key]
            getChildrenItem(element)
          }
        }
      }
    },
    /**
     * @description 本地存储方法
     */
    storeToLocal () {
      const addInfo = {
        signInfo: { ...this.signInfo }, // JSON.parse(JSON.stringify(this.addForm))
        baseInfo: { ...this.baseInfo },
        settleInfo: { ...this.settleInfo },
        otherInfo: { ...this.otherInfo },
        encryptedInfo: { ...this.encryptedInfo },
        licenseExpiryDate: { ...this.licenseExpiryDate },
        idCardExpiryDate: { ...this.idCardExpiryDate }
      }
      addInfo.signInfo.agentPassword = ''
      addInfo.signInfo.confirmPassword = ''
      localStorage.setItem('AGENT_ADD_INFO', JSON.stringify(addInfo))
    },
    /**
     * @description 有效期赋值
     * @param {Object} value 结果对象
     */
    getExpiryDate (value) {
      this.baseInfo[value.valueName] = value.longTermTag ? '2099-12-30' : value.dateEnd
      if (!this.isEdit && !this.readOnly) {
        this.storeToLocal()
      }
    },
    // 给对象赋值
    setInfo (val) {
      console.log(val)
      const longTermTag = ['2099-12-30', '长期', '永久', '不约定期限']
      this.setModuleInfo(this.signInfo, val)
      this.licenseExpiryDate.dateEnd = longTermTag.includes(val.licenseExpiryDate) ? '' : val.licenseExpiryDate
      this.licenseExpiryDate.longTermTag = longTermTag.includes(val.licenseExpiryDate)
      this.idCardExpiryDate.dateEnd = longTermTag.includes(val.legalIdCardExpiryDate) ? '' : val.legalIdCardExpiryDate
      this.idCardExpiryDate.longTermTag = longTermTag.includes(val.legalIdCardExpiryDate)
      this.setModuleInfo(this.baseInfo, val)
      this.setModuleInfo(this.settleInfo, val)
      this.setModuleInfo(this.otherInfo, val)
      this.setModuleInfo(this.encryptedInfo, val)
      this.needOcr = false
      setTimeout(() => {
        this.needOcr = true
      }, 100)
    },
    // 各模块循环赋值
    setModuleInfo (target, val) {
      for (const item in target) {
        target[item] = val[item] !== undefined ? val[item] : target[item]
      }
    },
    // 提交处理
    resolveSubmit (res) {
      this.submitLoading = false
      if (res.result_cde === '0') {
        this.$emit('success', Object.assign({}, {
          account: this.signInfo.agentAccount
        }, res.data))
        this.close()
      } else {
        this.$message({
          message: res.result_msg,
          type: 'error'
        })
      }
    },
    getMultiFiles (element) {
      if (!this.readOnly) {
        this.$refs[element].click()
      }
    },
    /**
     * @description 选择文件
     */
    getFile (event, type) {
      console.log(type)
      if (event.target.files[0].type.indexOf('jpg') < 0 && event.target.files[0].type.indexOf('jpeg') < 0 && event.target.files[0].type.indexOf('png') < 0 && event.target.files[0].type.indexOf('pdf') < 0) {
        this.$message({
          message: '不支持上传该类型文件',
          type: 'warning'
        })
        return
      }
      if (Math.round(event.target.files[0].size / 1024 / 1024 * 100) / 100 > 9) {
        this.$message({
          message: '文件大小不得大于9M，请重新上传！',
          type: 'warning'
        })
      }
      const file = event.target.files[0]
      const multiFileName = file.name
      const index = multiFileName.lastIndexOf('.')
      const fileType = multiFileName.substr(index + 1)
      const formData = new FormData()
      formData.append('fileType', fileType)
      formData.append('multipartFile', file)
      // 请求接口 获取数据 之后传数据给父组件
      uploadExtendFile(formData).then(res => {
        if (parseInt(res.error_code) === 0) {
          this.otherInfo[type] = res.path
          this.$message({
            message: res.error_msg || res.result_msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: res.error_msg || res.result_msg,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err)
        this.$message({
          showClose: true,
          message: '上传出错！',
          type: 'error'
        })
      })
      event.target.value = null
    },
    /**
     * @description 删除已上传文件
     */
    removeFile (type) {
      this.$confirm('是否确认删除文件？', '提示', {}).then(() => {
        this.otherInfo[type] = ''
      })
    },
    downloadLink (type) {
      const name = type === 'cooperationPic' ? '合作协议原件' : '租赁协议'
      let host
      if (process.env.NODE_ENV === 'production') {
        if (process.env.CUSTOM_ENV === 'test') {
          host = 'http://t-saas-combine.lepass.cn/zzgagent-pay-customer/' // 测试环境
        } else if (process.env.CUSTOM_ENV === 'pre') {
          host = 'http://p-saas-combine.lepass.cn/zzgagent-pay-customer/' // 预发布环境
        } else if (process.env.CUSTOM_ENV === 'prd') {
          host = '/zzgagent-pay-customer/' // 正式环境
        }
      } else {
        host = '/zzgagent-pay-customer/'
      }
      return this.otherInfo[type] ? `${host}/user-common/single-trans-file-download?path=${this.otherInfo[type]}&name=${name}` : ''
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.agentRegister{
  h1{
    margin-bottom: 20px;
  }
  .form-input {
    width: 450px;
  }
  .form-flex-item {
    margin-right: 5px;
  }
  .flexRow{
    .el-form-item{
      width: 150px;
      &+.el-form-item{
        margin-left: 20px;
      }
    }
  }
  .photos-content-view {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .photos-content-view{
    .el-form-item{
      width: 222px;
      text-align: center;
    }
  }
  .upload-link {
    text-decoration:underline;
  }
  .upload-link + span{
    margin-left: 10px;
  }
  .hasSelect .removeIcon{
    color:#F56C6C;
    line-height: 30px;
    cursor: pointer;
    margin-left: 10px;
  }
  .buttonDiv{
    text-align: center;
  }
  .errorMsg{
    font-size: 15px;
    margin: 10px 0;
    span{
      color: red;
    }
  }
}
</style>
<style lang="scss">
.agentRegister{
  &.isInstitution {
    margin-left: 20px;
    padding-bottom: 20px;
    .el-card__body {
      padding-top: 0px;
    }
  }
  .el-collapse-item__arrow {
    margin: 0 8px 0 10px;
  }
  .el-collapse-item__wrap{
    border:none
  }
  .el-divider--horizontal{
    margin: 0 0 10px 0;
  }
}
.successDiv{
  .el-button{
    width: 280px;
    height: 46px;
    margin-top: 37px;
    font-size: 16px;
  }
}
</style>
